import { FIREBASE_IMAGE } from "../config/constant";

export default class User {
  constructor(data = {}, uid) {
    this.uid = uid;
    this.kind = data.kind ?? 0; // 0: analysis, 1: user, 2: model
    this.email = data.email;
    this.name = data.name;
    this.image = data.image;
    this.introduction = data.introduction;
    this.height = data.height;
    this.weight = data.weight;
    this.gender = data.gender; // 2: woman, 1: man
    this.imgFace = data.imgFace;
    this.cntFollower = data.cntFollower ?? 0;
    this.cntFollowing = data.cntFollowing ?? 0;
    this.token = data.token;
    this.deviceName = data.deviceName;

    // model data
    this.imgFront = data.imgFront;
    this.imgBack = data.imgBack;
    this.approve = data.approve; // 0: applicate 1: reject 2: success
    this.modelName = data.modelName;
    this.modelNameKana = data.modelNameKana;
    this.modelGender = data.modelGender;
    this.modelBirthday = data.modelBirthday;
    this.modelEmail = data.modelEmail;
    this.modelTel = data.modelTel;
    this.image1 = data.image1;
    this.image2 = data.image2;
    this.image3 = data.image3;

    // timestamp
    this.timestamp = data.timestamp;
    this.modelTimestamp = data.modelTimestamp;

    // block
    this.isBlocked = data.isBlocked;
    this.isTestAccount = data.isTestAccount;
    this.authType = data.authType;
    this.brandId = data.brandId;
    this.managingBrandId = data.managingBrandId;
    this.approveAdminEmail = data.approveAdminEmail;
    this.rakutenTrackingId = data.rakutenTrackingId;
  }

  static imageUrl(key, image) {
    return FIREBASE_IMAGE(`users%2F${key}`, image);
  }
}
